<template>
	<section class="hero">
		<div class="hero__container">
			<GlobalImage
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				class="hero__image"
				:alt="title"
				:src="bannerIMG ? `${storageUrl}${bannerIMG}` : 'medium-term-hero-v2.png'"
				:height="800" />
			<GlobalImage
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				class="hero__image hero__image--mobile"
				:alt="title"
				:src="bannerIMG ? `${storageUrl}${bannerIMG}` : 'medium-term-hero-mobile-v2.png'"
				:height="748" />
			<div class="hero__gradient"></div>
			<h1 data-aos="fade-up" class="hero__title">{{ title }}</h1>
			<a v-if="!hideContactForm" data-aos="fade-up" data-aos-delay="200" href="#contact-form" class="hero__btn">{{
				$t('modules.medium_term_page_module.fill_out_get_offer')
			}}</a>
			<div v-if="booker" ref="bookerContainerRef" class="hero__booker-container" data-aos="fade-up" data-aos-delay="200">
				<div class="hero__global-booker-wrapper" :style="{ minHeight: bookerHeight ? `${bookerHeight}px !important` : 'unset' }">
					<GlobalBooker v-if="!isNavBookerVisible || top > 100" />
				</div>
			</div>
		</div>
	</section>
</template>

<script lang="ts" setup>
const bannerIMG = ref<string>()
const pageHeaderSection = inject<Ref<ICMSLocationContent>>('pageHeaderSection') || ref<ICMSLocationContent>([])

const { isTablet_sm } = useWindowWidth()
const bookerTarget = inject<HTMLElement>('bookerTarget')
const { top } = useElementBounding(bookerTarget)
const isNavBookerVisible = inject<Ref<boolean>>('isNavBookerVisible')
const bookerHeight = ref()
const { storageUrl } = useStorageService()

const props = defineProps<{
	title: string
	booker?: boolean
	hideContactForm?: boolean
}>()

const assignBannerIMG = () => {
	if (!pageHeaderSection.value) return null
	if (pageHeaderSection.value.files && pageHeaderSection.value.files.length > 0) {
		const img = pageHeaderSection.value.files[0].path
		if (img) bannerIMG.value = img
	}
}

assignBannerIMG()

const assignBookerWrapperHeight = () => {
	if (bookerHeight.value) return

	const globalBooker = document.querySelector('.hero__global-booker-wrapper')
	if (globalBooker) {
		bookerHeight.value = globalBooker.clientHeight
	}
}
const bookerContainerRef = ref<HTMLElement | null>(null)

watch(
	() => isTablet_sm.value,
	(newVal) => {
		// when bookerHeight will be saved on mobile, and user will resize to desktop, header view might be broken - FIX for that
		if (!newVal && bookerHeight.value > 300) {
			bookerHeight.value = 0
		}
	},
)

onMounted(() => {
	if (props.booker) {
		window.addEventListener('scroll', assignBookerWrapperHeight)

		setTimeout(() => {
			if (bookerContainerRef.value) {
				bookerContainerRef.value.style.transform = 'none'
			}
		}, 250)
	}
})
onBeforeUnmount(() => {
	if (props.booker) {
		try {
			window.removeEventListener('scroll', assignBookerWrapperHeight)
		} catch (error) {
			console.error(error)
		}
	}
})
</script>

<style scoped lang="scss">
@import './PageHero.scss';
</style>
